<div *ngIf="currentJob" class="bmc-jobs-steps">
    <table class="bz-table bz-space--stack-xl">
        <thead>
            <tr>
                <th *ngIf="jobType !== jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_ID' | translate }}</span>
                    </div>
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_NAME' | translate }}</span>
                    </div>
                </th>
                <th class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_DESCRIPTION' | translate }}</span>
                    </div>
                </th>
                <th *ngIf="jobType === jobTypes.User" class="bz-table__cell bz-table__cell--sortable">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{ 'JOBS.COLUMN_CODE' | translate }}</span>
                    </div>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let step of currentJob.steps">
                <td *ngIf="jobType !== jobTypes.User" class="bz-table__cell">
                    {{ step.idJob }}
                </td>

                <td class="bz-table__cell">
                    <ng-container>
                        {{ step.jsName || step.name }}
                    </ng-container>                    
                </td>

                <td class="bz-table__cell">
                    <ng-container>
                        {{ step.jsDescription || step.description }}
                    </ng-container>                    
                </td>

                <td *ngIf="jobType === jobTypes.User" class="bz-table__cell bmc-jobs-steps__table--cell-text">
                    {{ step.jsCode || step.ruleDisplayName }}
                </td>
            </tr>
        </tbody>
    </table>
</div>